export const CHAR_CONCAT_SET = [':','：',';','；',',', '，', '.', '。'];

export const FEATURE_DISMANTLING_DB = 'FeatureDismantlingDB';

export const CLAIM_FEATURE_DB_KEY = 'claimFeatureData';

export const PARAMS_ID_DEFAULT = 'DEFAULT';

export const ID_PREFIX = 'PID-';

export const COMPARE_PATENT_LATEST_DATA = 'CPatent-latestData';

export const CLAIM_CHARTING_MARK_CLASS_NAME = 'claim-charting-mark';

export const COMPARE_ORIGINAL_WRAPPER_CLASS_NAME = 'pt-section__body';
